export { renderTokens }

import type { ReactNode } from 'react'

// Syntax-highlight one line of the license snippet — the single source of truth for its token
// markup, shared by the dashboard's `LicenseKeysPanel` and license-components' `FreeTrialForm`.
//
// Approximates Shiki's `github-light` theme (docpress's, which powers vike.dev/docs) without the
// dependency: single-quoted string literals blue, `export`/`default` keywords red. The snippet is
// a fixed shape and its strings hold only domains + base64url keys (no nested quotes / keywords),
// so this split-based tokenizer is unambiguous. Emits `.tok-str` / `.tok-kw` spans; the matching
// CSS lives in `LicenseSnippet`'s scoped `<style>` — its sole consumer, which both the dashboard
// and FreeTrialForm render through.
function renderTokens(text: string): ReactNode {
  const nodes: ReactNode[] = []
  text.split(/('[^']*')/g).forEach((seg, i) => {
    if (i % 2 === 1) {
      nodes.push(
        <span key={i} className="tok-str">
          {seg}
        </span>,
      )
      return
    }
    seg.split(/\b(export|default)\b/g).forEach((part, j) => {
      if (!part) return
      if (j % 2 === 1) {
        nodes.push(
          <span key={`${i}-${j}`} className="tok-kw">
            {part}
          </span>,
        )
      } else {
        nodes.push(part)
      }
    })
  })
  return nodes
}
